import { render } from "./DashboardAddUser.vue?vue&type=template&id=abb56086"
import script from "./DashboardAddUser.vue?vue&type=script&lang=js"
export * from "./DashboardAddUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__